
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { AnalyticEvent } from './AnalyticEvent';
import { fireBaseAnalytic } from './firebase/FireBaseAnalytic';
import * as Sentry from "@sentry/browser";

export interface AnalyticProvider {
    sendEvent(event: AnalyticEvent): void;
    setUserAddress(address:string):void;
}

//Does that work because we are servlerss?
//I mean we can have it as a singleton because we do one query after the other
class AnalyticFacade implements AnalyticProvider{

    providers:AnalyticProvider[];

    constructor(){
        this.providers =[];
        this.providers.push(fireBaseAnalytic);
    }

    setUserAddress(address:string) {

        // console.log("Fire Event", event);
         
        Sentry.setUser({id:address}) ;

         for(let i = 0;i < this.providers.length; i++){
             this.providers[i].setUserAddress(address);
         }
     }

    sendEvent(event: AnalyticEvent) {

       // console.log("Fire Event", event);
        
        for(let i = 0;i < this.providers.length; i++){
            this.providers[i].sendEvent(event);
        }
    }
}

export const facade: AnalyticFacade = new AnalyticFacade();